import { BaseSecondSidebarPageContent } from "../../shared/components/base/page/BaseSecondSidebarPageContent";
import { IConnectRender } from "../../shared/components/definitions/IConnectRender";
import { MonitoreoBrocaMapRender } from "../../shared/components/modulos/monitoreo/broca/map/MonitoreoBrocaMapRender";
import { MonitoreoBrocaSecondSidebarRender } from "../../shared/components/modulos/monitoreo/broca/sidebar/MonitoreoBrocaSecondSidebarRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { APP_RUTA_FINCA } from "../components/ClienteAsideMenuRender";

/** Página del módulo de Monitoreo Broca: segundo sidebar (semanas agrupadas
 *  por año, con el detalle de lotes expandible) + mapa con los lotes
 *  coloreados según la métrica de la semana seleccionada. */
export class MonitoreoBrocaPage extends BaseSecondSidebarPageContent {
  /** Mapa vivo de la página (el sidebar le cambia la semana mostrada). */
  private _mapRender: MonitoreoBrocaMapRender | null = null;

  /** El mapa de monitoreo de broca (contenido principal). */
  protected getMainRender(): IConnectRender {
    this._mapRender = new MonitoreoBrocaMapRender();
    return this._mapRender;
  }

  /** Sidebar de monitoreo de broca: volver → mapa de finca; seleccionar una
   *  semana → pinta esos lotes en el mapa. */
  protected getSecondSidebarRender(): IConnectRender {
    return new MonitoreoBrocaSecondSidebarRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA),
      (semana) => this._mapRender?.setSemana(semana.registros),
    );
  }
}
